export const sendGaEvent = (eventName: string, payload = {}) => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'GA_Event',
      eventName,
      ...payload,
    });
};
